import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
import { ref } from "vue";
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import { PlayerContractNegotiationStarter } from "@/modules/team/services/PlayerContractNegotiationStarter";
import { Team } from "@/modules/team/entity";
import RichDialogRow from "@/modules/vue/components/RichDialogRow.vue";
import Stepper from "@/modules/vue/components/Stepper.vue";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import Flag from "@/modules/vue/components/Flag.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerContractNegotiationStarter',
  emits: ['started'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const currentPlayer = ref();
    const years = ref();
    const maxYears = computed(() => app.get(ConfigRepository).get('players.contract.maxYears'));
    const hasMaxContractDuration = computed(() => currentPlayer.value && currentPlayer.value.contractYears === maxYears.value);
    const willEndCareer = computed(() => currentPlayer.value && currentPlayer.value.endsCareer);
    const confirmation = ref(null);
    const negotiator = app.get(PlayerContractNegotiationStarter);
    const negotiate = async player => {
      currentPlayer.value = player;
      years.value = player.contractYears + 1;
      const contractContainerFactory = app.get("Factory<PlayerContractNegotiationContainer>");
      await nextTick(async () => {
        await confirmation.value.confirm();
        const negotiation = await negotiator.start(await Team.current(), contractContainerFactory(player, years.value));
        emit('started', negotiation);
      });
    };
    expose({
      negotiate
    });
    return (_ctx, _cache) => {
      const _component_NAlert = _resolveComponent("NAlert");
      return _openBlock(), _createBlock(RichDialog, {
        ref_key: "confirmation",
        ref: confirmation,
        "confirmation-disabled": _unref(hasMaxContractDuration)
      }, _createSlots({
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('start_contract_negotiations')), 1)]),
        default: _withCtx(() => [_unref(hasMaxContractDuration) ? (_openBlock(), _createBlock(_component_NAlert, {
          key: 0,
          type: "error"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('the_player_has_the_maximum_contract_duration')), 1)]),
          _: 1
        })) : _unref(willEndCareer) ? (_openBlock(), _createBlock(_component_NAlert, {
          key: 1,
          type: "error"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('the_player_will_end_career_at_the_end_of_his_contract')), 1)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_NAlert, {
          key: 2,
          type: "warning"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('you_can_not_change_target_contract_duration_after_the_negotiation_started')), 1)]),
          _: 1
        }))]),
        _: 2
      }, [!_unref(hasMaxContractDuration) ? {
        name: "rows",
        fn: _withCtx(() => [_createVNode(RichDialogRow, null, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player')), 1)]),
          value: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(Flag, {
            country: currentPlayer.value.country,
            class: "mr-2"
          }, null, 8, ["country"]), _createTextVNode(" (" + _toDisplayString(currentPlayer.value.age) + ") " + _toDisplayString(currentPlayer.value.shortName), 1)])]),
          _: 1
        }), _createVNode(RichDialogRow, null, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('current_duration')), 1)]),
          value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(currentPlayer.value.contractYears, 'years').humanize()), 1)]),
          _: 1
        }), _createVNode(RichDialogRow, null, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('new_duration')), 1)]),
          value: _withCtx(() => [_createVNode(Stepper, {
            modelValue: years.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => years.value = $event),
            min: currentPlayer.value.contractYears + 1,
            max: _unref(maxYears),
            "input-readonly": "",
            formatter: value => _ctx.$duration(value, 'years').humanize()
          }, null, 8, ["modelValue", "min", "max", "formatter"])]),
          _: 1
        })])
      } : undefined]), 1032, ["confirmation-disabled"]);
    };
  }
});